import React from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-brand-border bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid md:grid-cols-4 gap-10">
        <div>
          <Link to="/" className="flex items-center gap-2 font-heading font-bold text-brand-blue text-xl mb-3">
            <span className="inline-flex w-8 h-8 rounded-xl bg-brand-blue text-white items-center justify-center">
              <Sparkles size={16} />
            </span>
            FuturePath
          </Link>
          <p className="text-sm text-brand-muted leading-relaxed max-w-xs">
            Helping parents design the future of their children — from age 2 to adulthood.
          </p>
          <p className="mt-3 text-xs text-brand-muted">
            <a href="https://future-path.in" target="_blank" rel="noreferrer" className="text-brand-blue font-medium hover:text-brand-green">future-path.in</a>
          </p>
        </div>
        <div>
          <div className="overline mb-3">Explore</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/assessment" className="text-brand-muted hover:text-brand-blue">Assessment</Link></li>
            <li><Link to="/curriculum" className="text-brand-muted hover:text-brand-blue">Curriculum</Link></li>
            <li><Link to="/activities" className="text-brand-muted hover:text-brand-blue">Activities</Link></li>
            <li><Link to="/marketplace" className="text-brand-muted hover:text-brand-blue">Shop</Link></li>
            <li><Link to="/careers" className="text-brand-muted hover:text-brand-blue">Future careers</Link></li>
            <li><Link to="/assistant" className="text-brand-muted hover:text-brand-blue">AI Assistant</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline mb-3">Community</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/communities" className="text-brand-muted hover:text-brand-blue">Communities</Link></li>
            <li><Link to="/tutors" className="text-brand-muted hover:text-brand-blue">Tutors</Link></li>
            <li><Link to="/mentors" className="text-brand-muted hover:text-brand-blue">Mentors</Link></li>
            <li><Link to="/impact" className="text-brand-muted hover:text-brand-blue">Learning for All</Link></li>
            <li><Link to="/pricing" className="text-brand-muted hover:text-brand-blue">Pricing</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline mb-3">Company</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" data-testid="footer-about-link" className="text-brand-muted hover:text-brand-blue">About</Link></li>
            <li><Link to="/contact" data-testid="footer-contact-link" className="text-brand-muted hover:text-brand-blue">Contact</Link></li>
            <li><Link to="/privacy" data-testid="footer-privacy-link" className="text-brand-muted hover:text-brand-blue">Privacy</Link></li>
            <li><Link to="/terms" data-testid="footer-terms-link" className="text-brand-muted hover:text-brand-blue">Terms</Link></li>
            <li><Link to="/feedback" data-testid="footer-feedback-link" className="text-brand-orange font-medium hover:text-brand-blue">Share feedback →</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-brand-border">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 text-xs text-brand-muted flex flex-col sm:flex-row items-center justify-between gap-2">
          <span>© {new Date().getFullYear()} FuturePath Learning. All rights reserved.</span>
          <span>Made with warmth for parents who care.</span>
        </div>
      </div>
    </footer>
  );
}
